<div class="container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h6">Token for Shopify</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-input
          [disabled]="true"
          formControlName="usageToken"
          label="Copy & paste this into Shopify's components by 'Dynamic Reviews token'"
          [clipboard]="true"></pdq-input>
        <pdq-extension-preview-token [usageTokenControl]="formGroup.get('usageToken')"></pdq-extension-preview-token>
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div><pdq-heading element="h6">General</pdq-heading></div>
      <pdq-divider></pdq-divider>
      <div>
        <pdq-input
          label="Internal name"
          formControlName="internalName"
          [invalid]="formGroup.get('internalName')?.touched && formGroup.get('internalName')?.hasError('required')"
          invalidMsg="Internal name is required"></pdq-input>
        <pdq-input
          label="Internal description"
          formControlName="internalDescription"
          placeholder="Display product reviews at checkout"></pdq-input>
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div class="section-header">
        <pdq-heading element="h6">Import Method</pdq-heading>
        <span class="section-subtitle">Choose how you'd like to import your product reviews.</span>
      </div>
      <pdq-divider></pdq-divider>

      <div class="import-method-section">
        <pdq-review-platform-picker [formGroup]="formGroup"></pdq-review-platform-picker>

        @if (isCsvSelected) {
          <pdq-review-csv-upload [formGroup]="formGroup"></pdq-review-csv-upload>
        }
      </div>
    </div>
  </pdq-card>

  <pdq-card variant="popover" color="white">
    <pdq-collapsed [initialCollapsed]="false" (onChange)="isReviewRulesCollapsed = $event">
      <pdq-collapsed-header padding="0 var(--padding-16)">
        <div class="section-header">
          <pdq-heading element="h6">Review Rules</pdq-heading>
          <span class="section-subtitle">Filter which reviews shoppers see at checkout</span>
        </div>
        <pdq-collapsed-trigger>
          <pdq-icon
            class="collapse-arrow"
            [icon]="isReviewRulesCollapsed ? 'collaping-arrow-down' : 'collapsing-arrow-up'"></pdq-icon>
        </pdq-collapsed-trigger>
      </pdq-collapsed-header>
      <pdq-collapsed-content>
        <div class="card-content">
          <pdq-divider class="card-divider"></pdq-divider>
          <pdq-banner variant="info" [closable]="false">
            <span bannerTitle
              ><span class="emphasis">Fallback Settings</span> and
              <span class="emphasis">Reviews To Display</span> apply only to
              <span class="emphasis">Carousel &amp; List</span> layouts.</span
            >
          </pdq-banner>
          <div class="review-rules-section">
            <div class="fallback-settings-row" formGroupName="fallbackSettings">
              <div class="rule-header">
                <span class="toggle-label">Fallback Settings</span>
                <pdq-slide-toggle formControlName="enabled"></pdq-slide-toggle>
              </div>
              <span class="rule-description">Define fallback text to show for products without reviews</span>
              @if (formGroup.controls.fallbackSettings.controls.enabled.value) {
                <div class="fallback-text-input">
                  <pdq-input formControlName="text" placeholder="Customers love this product!"></pdq-input>
                </div>
              }
            </div>
          </div>

          <div class="reviews-count-section">
            <span class="reviews-count-title">Reviews To Display</span>
            <div class="reviews-count-row">
              <div class="reviews-count-row-labels">
                <span class="reviews-count-text">Display up to</span>
                <span class="reviews-count-sublabel">Max reviews shown</span>
              </div>
              <pdq-input-arrows formControlName="reviewsToDisplay" [min]="1" widthSize="small"></pdq-input-arrows>
              <span class="reviews-count-text">reviews</span>
            </div>
          </div>

          <pdq-divider></pdq-divider>

          <div class="filters-section">
            <span class="filters-title">Filters</span>

            <div class="filter-row">
              <div class="rule-header">
                <span class="toggle-label">Star Rating</span>
                <pdq-slide-toggle formControlName="minStarRatingEnabled"></pdq-slide-toggle>
              </div>
              <span class="rule-description">Only show reviews with this rating or higher</span>
              @if (formGroup.controls.minStarRatingEnabled.value) {
                <div class="rule-input-row">
                  <pdq-input-arrows
                    formControlName="minStarRating"
                    [min]="minStarRatingMin"
                    [max]="minStarRatingMax"
                    [step]="minStarRatingStep"
                    [precision]="1"
                    widthSize="medium"></pdq-input-arrows>
                  <span class="rule-inline-label">stars and above</span>
                  <pdq-star-rating [rating]="formGroup.controls.minStarRating.value"></pdq-star-rating>
                </div>
              }
            </div>

            <div class="filter-row">
              <div class="rule-header">
                <span class="toggle-label">Amount Of Reviews</span>
                <pdq-slide-toggle formControlName="minNumberOfReviewsEnabled"></pdq-slide-toggle>
              </div>
              <span class="rule-description">Only show reviews on products that have at least this many reviews</span>
              @if (formGroup.controls.minNumberOfReviewsEnabled.value) {
                <div class="rule-input-row">
                  <pdq-input-arrows
                    formControlName="minNumberOfReviews"
                    [min]="1"
                    widthSize="medium"></pdq-input-arrows>
                  <span class="rule-inline-label">reviews and above</span>
                </div>
              }
            </div>

            <div class="filter-row">
              <div class="rule-header">
                <span class="toggle-label">Exclude Products</span>
                <pdq-slide-toggle formControlName="excludeProductsEnabled"></pdq-slide-toggle>
              </div>
              <span class="rule-description">Reviews from these products won&apos;t show at checkout</span>
              @if (formGroup.controls.excludeProductsEnabled.value) {
                <pdq-segmented-control
                  [options]="exclusionModeOptions"
                  [value]="isManualExclusion ? ExclusionMode.MANUAL : ExclusionMode.SMART"
                  (valueChange)="setExclusionMode($event)">
                </pdq-segmented-control>

                @if (isManualExclusion) {
                  <div class="product-list-section">
                    <div class="product-list-section__header">
                      <span class="product-list-section__label">Excluded Products ({{ excludedProducts.length }})</span>
                      <pdq-button
                        variant="dark"
                        size="small"
                        label="+Add Products"
                        (onClick)="addExcludedProducts.emit()"></pdq-button>
                    </div>
                    <pdq-product-list
                      [products]="excludedProducts"
                      [showSearch]="true"
                      [showRemove]="true"
                      searchPlaceholder="Search..."
                      emptyMessage="No products excluded"
                      (remove)="removeExcludedProduct.emit($event.id)">
                    </pdq-product-list>
                  </div>
                } @else {
                  <pdq-rules-dynamic-form
                    [formGroup]="formGroup"
                    formArrayFieldName="excludeProductsRules"
                    [rules]="excludeProductsRules"
                    [entities]="excludeProductsEntities"
                    [versionWithOrOperator]="true">
                  </pdq-rules-dynamic-form>
                }
              }
            </div>
          </div>
        </div>
      </pdq-collapsed-content>
    </pdq-collapsed>
  </pdq-card>
</div>
